<template>
  <div class="time-box">
    <div class="time-title">距2027年高考仅有:</div>
    <div class="content">
      <span class="tian">{{ data.d }}</span>
      天
    </div>
    <div class="time-text">
      拼一载春秋  博一生无悔
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
const date = new Date();
const data = reactive({
  year: date.getFullYear(),
  month: date.getMonth() + 1,
  day: date.getDate(),
  d: "",
});
function getRTime() {
  var EndTime = new Date("2027/06/07 00:00:00"); //截止时间
  var NowTime = new Date();
  var t = EndTime.getTime() - NowTime.getTime();
  var d = Math.floor(t / 1000 / 60 / 60 / 24);
  data.d = d > 0 ? d : 0;
}
getRTime();
setInterval(getRTime, 1000);
</script>

<style lang="scss" scoped>
.time-box {
  width: 170px;
  height: 100px;
  border: 1px solid #c1c1c1;
  background-color: #fff;
  position: absolute;
  right: 30px;
  top: 20px;
  border-radius: 8px;
  overflow: hidden;
  .time-title {
    height: 25px;
    width: 100%;
    background-color: #e52a23;
    text-align: center;
    line-height: 25px;
    font-size: 12px;
    color: #f1f1f1;
  }
  .content {
    font-size: 20px;
    color: #686868;
    text-align: center;
    .tian {
      font-size: 40px;
    }
  }
  .time-text {
    font-size: 14px;
    color: #818181;
    text-align: center;
  }
}
</style>
